import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock';
import PerfectScrollbar from 'perfect-scrollbar';
export const toggleMenu = (selector) => {
    return new ToggleMenu(selector);
};
/**
 * トグルメニュークラス
 */
class ToggleMenu {
    menuEl;
    scrollBoxEl;
    headEl;
    scrollBar;
    isShow = false;
    // トグルアニメーション系
    duration = 300;
    classNameEnter = 'enter';
    classNameEnterDone = 'enter-done';
    classNameEnterActive = 'enter-active';
    classNameLeave = 'leave';
    classNameLeaveDone = 'leave-done';
    classNameLeaveActive = 'leave-active';
    timerID = null;
    onBeforeOpen;
    onBeforeClose;
    /**
     * コンストラクタ
     */
    constructor(selector) {
        const menuEl = document.querySelector(selector);
        if (menuEl) {
            this.menuEl = menuEl;
        }
        const scrollBoxEl = this.menuEl?.querySelector('.toggle-menu-scrollbox');
        if (scrollBoxEl) {
            this.scrollBoxEl = scrollBoxEl;
            this.scrollBar = new PerfectScrollbar(this.scrollBoxEl, {
                suppressScrollX: false
            });
        }
        // スクロールエリアのサイズ計算に使用するヘッドエリアの要素を得る
        const headEl = menuEl.querySelector('.toggle-menu-head');
        if (headEl) {
            this.headEl = headEl;
        }
    }
    /**
     * イベントのセット
     */
    on(eventType, callback) {
        if (eventType === 'beforeOpen') {
            this.onBeforeOpen = callback;
        }
        if (eventType === 'beforeClose') {
            this.onBeforeClose = callback;
        }
    }
    /**
     * 表示トグル
     */
    toggle() {
        if (!this.menuEl) {
            return;
        }
        // フラグの反転
        this.isShow = !this.isShow;
        // タイマーの停止
        if (this.timerID) {
            clearTimeout(this.timerID);
        }
        this.menuEl.classList.remove(this.isShow ? this.classNameLeave : this.classNameEnter);
        this.menuEl.classList.remove(this.isShow ? this.classNameLeaveActive : this.classNameEnterActive);
        this.menuEl.classList.remove(this.isShow ? this.classNameLeaveDone : this.classNameEnterDone);
        this.menuEl.classList.add(this.isShow ? this.classNameEnter : this.classNameLeave);
        // アニメーション発火のため、アクティブクラスの付与を遅延させる
        setTimeout(() => {
            if (this.menuEl) {
                this.menuEl.classList.add(this.isShow ? this.classNameEnterActive : this.classNameLeaveActive);
            }
        }, 1);
        // スクロールの有効無効切り替え
        this.toggleScrollLock(this.isShow);
        // 表示完了 or 非表示完了
        this.timerID = setTimeout(() => {
            if (this.menuEl) {
                this.menuEl.classList.remove(this.isShow ? this.classNameEnter : this.classNameLeave);
                this.menuEl.classList.remove(this.isShow ? this.classNameEnterActive : this.classNameLeaveActive);
                this.menuEl.classList.add(this.isShow ? this.classNameEnterDone : this.classNameLeaveDone);
                // 表示完了の場合
                if (this.isShow) {
                    // スクロールサイズのアップデート
                    this.updateScrollBar();
                }
            }
        }, this.duration);
        // コールバックの実行
        if (this.isShow) {
            if (this.onBeforeOpen !== undefined) {
                this.onBeforeOpen();
            }
        }
        else {
            if (this.onBeforeClose !== undefined) {
                this.onBeforeClose();
            }
        }
        // 表示ふらぐを返す
        return this.isShow;
    }
    /**
     * スクロールエリアのアップデート
     */
    updateScrollBar() {
        // ビューポートの高さ
        const clientHeight = document.documentElement.clientHeight;
        if (this.headEl && this.scrollBoxEl && this.scrollBar) {
            // ヘッドの高さ
            const headHeight = this.headEl.getBoundingClientRect().height;
            // スクロールエリアの高さをもとめる
            this.scrollBoxEl.style.height = `${clientHeight - headHeight}px`;
            // アップデート
            this.scrollBar.update();
        }
    }
    /**
     * スクロール有効無効の切り替え
     */
    toggleScrollLock(isShow) {
        if (!this.scrollBoxEl) {
            return;
        }
        if (isShow) {
            // 現在のスクロール座標をもとめる
            const scrollPosition = window.pageYOffset;
            const bodyEl = document.querySelector('body');
            disableBodyScroll(this.scrollBoxEl);
            if (bodyEl) {
                bodyEl.style.top = `-${scrollPosition}px`;
            }
        }
        else {
            enableBodyScroll(this.scrollBoxEl);
        }
    }
}
